import { gql } from '@apollo/client';

const READ_LAST_RECURRING_PAYMENT = gql`
  query ReadLastRecurringPayment(
    $input: ReadSalesOrderRecurringPaymentStatusInput!
  ) {
    readLastRecurringPayment(input: $input) {
      chargeUid
      failureDate
      isFailed
      orderLineId
      salesOrderUid
      validity {
        validFrom
        validTo
      }
    }
  }
`;

export default READ_LAST_RECURRING_PAYMENT;
